<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4" v-if="currpage == 'list'">
        <b-col>
          <b-card>
            <div class="p-3" v-if="storelist">
              <div>{{ $t('Online Store') }} <el-button type="primary" class="ml-6" size="small" @click="back_to_store">{{ $t("Back") }}</el-button></div>
              <el-table
                stripe
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="storelist"
                @row-click="row_clicked_event"
              >
                <el-table-column label="ID" prop="IDn">
                  <template v-slot:row>
                    {{ row.IDn }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Store')" prop="LocationID">
                </el-table-column>
                <el-table-column :label="$t('Type')" prop="SourceType">
                </el-table-column>
                <el-table-column :label="$t('Name')" prop="SourceName">
                </el-table-column>
                <el-table-column :label="$t('Status')">
                  <template slot="header">
                    <i @click="add_store()" class="el-icon-circle-plus float-right mt-1 mr-6" style="color: #409eff"></i>
                  </template>
                  <template slot-scope="scope">
                    <div v-if="scope.row.Status==0">{{ $t("Close") }}</div>
                    <div v-else>{{ $t("Open_Store") }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-else>
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-form>
                <b-row class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Store') }}
                      </b-col>
                      <b-col class="col-7">
                        {{ cur_store.LocationID }} <span v-if="cur_store.IDn"> -- {{ cur_store.IDn }}</span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Store Type') }}
                      </b-col>
                      <b-col class="col-7">
                        <select class="form-control input_height_1_5" v-model="cur_store.SourceType" @change="changedSourceType">
                          <option value="pandaraw">Panda Direct</option>
                          <option value="pandaapi">Panda API</option>
                          <option value="ubereat">Uber Eat</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Status') }}
                      </b-col>
                      <b-col class="col-1">
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="cur_store.Status"
                          id="inlineRadio2"
                          value="0"
                        />
                        <label class="form-check-label" for="inlineRadio1">{{
                          $t("Close")
                        }}</label>
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="cur_store.Status"
                          id="inlineRadio2"
                          value="1"
                        />
                        <label class="form-check-label" for="inlineRadio2">{{
                          $t("Open_Store")
                        }}</label>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          {{ $t('Store Name') }}
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Store ID"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SourceName"
                        />
                        <p>your store name for api server</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          {{ $t('Secure Key') }}
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SecureKey"
                        />
                        <p>secure key for api server</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        PosKing API URL
                        <p>change only if you need</p>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="URL"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SourceURL"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="cur_store.SourceType=='ubereat'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Uber Eat Store ID
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="UberEatStoreID"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Uber Eat Password
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="UberEatPassword"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="cur_store.SourceType=='pandaapi'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store ID
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Store ID"
                          class="form-control input_height_1_5"
                          v-model="PandaStoreID"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store Access Key
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Access Key"
                          class="form-control input_height_1_5"
                          v-model="PandaAccessKey"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store Security Key
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Security Key"
                          class="form-control input_height_1_5"
                          v-model="PandaSecurityKey"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="justify-content-lg-center mt-3">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                          Menu
                      </b-col>
                      <b-col class="col-7">
                        <select class="form-control input_height_1_5" v-model="Menu_IDn">
                          <option v-for="menu in menuList" :key="menu.IDn" :value="menu.IDn">{{ menu.Name1 }}</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                  </b-col>
                  <b-col cols="4">
                  </b-col>
                </b-row>
                <b-row class="justify-content-lg-center mt-3">
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_cancel">{{ $t("Back")}}</el-button>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="upload_online_menu" :disabled="cur_store.IDn==0">Upload Online Menu</el-button>
                    <p>Upload Store Menu ...</p>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="get_api_info" :disabled="cur_store.IDn==0">Get Store Status</el-button>
                    <p>Check Store Connection ...</p>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_submit">{{ $t("Submit") }}</el-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="text_message">
        <b-col>
          <b-card no-body>
            {{ text_message }}
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Button } from "element-ui";
import { getStore, setStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
  },
  data() {
    return {
      currpage: "list",
      new_store: {
        IDn: 0,
        LocationID: '',
        SourceType: "pandaraw", // pandaraw, pandaapi, ubereat
        SourceName: "",
        Status: 1,
        SecureKey: "",
        SourceURL: "https://api.posking.ca/Api",
        SourceParameter: "",
      },
      storelist: null,
      cur_store: {},
      menuList: null,
      Menu_IDn: 0,

      UberEatStoreID: "",
      UberEatPassword: "",

      PandaStoreID: "",
      PandaAccessKey: "",
      PandaSecurityKey: "",

      token: "",
      user_id: 0,

      text_message: "",
    };
  },
  methods: {
    hasUtilityAuth,
    changedSourceType() {
      if (this.cur_store.SourceType == "pandaraw") {
        this.cur_store.SourceURL = "https://api.posking.ca/Api/getMyOrders";
      } else {
        this.cur_store.SourceURL = "https://api.posking.ca/Api";
      }
    },
    back_to_store() {
      this.$router.push("/store");
    },
    add_store() {
      if (!hasUtilityAuth('StoreEdit')) return;
      this.currpage = "edit";
      this.cur_store = JSON.parse(JSON.stringify(this.new_store));
      this.text_message = "";
      // this.cur_store.LocationID = this.new_store.LocationID; // This is done at init
    },
    row_clicked_event(row, column, event) {
      // console.log("row_clicked_event", row, event, column);
      if (!hasUtilityAuth('StoreEdit')) return;
      this.currpage = "edit";
      this.cur_store = JSON.parse(JSON.stringify(row));
      this.text_message = "";
      this.UberEatStoreID = "";
      this.UberEatPassword = "";
      this.PandaStoreID = "";
      this.PandaAccessKey = "";
      this.PandaSecurityKey = "";
      if (this.cur_store.SourceType =="ubereat") {
        let json = JSON.parse(this.cur_store.SourceParameter);
        if (json.hasOwnProperty("UberEatStoreID")) {
          this.UberEatStoreID = json.UberEatStoreID;
        }
        if (json.hasOwnProperty("UberEatPassword")) {
          this.UberEatPassword = json.UberEatPassword;
        }
      } else if (this.cur_store.SourceType =="pandaapi") {
        let json = JSON.parse(this.cur_store.SourceParameter);
        if (json.hasOwnProperty("PandaStoreID")) {
          this.PandaStoreID = json.PandaStoreID;
        }
        if (json.hasOwnProperty("PandaAccessKey")) {
          this.PandaAccessKey = json.PandaAccessKey;
        }
        if (json.hasOwnProperty("PandaSecurityKey")) {
          this.PandaSecurityKey = json.PandaSecurityKey;
        }
      }
    },
    form_cancel() {
      this.currpage = "list";
      this.text_message = "";
    },
    async form_submit(event) {
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      var that = this;
      if (this.cur_store.SourceType =="ubereat") {
        this.cur_store.SourceParameter = JSON.stringify({
          UberEatStoreID: this.UberEatStoreID,
          UberEatPassword: this.UberEatPassword,
        });
      } else if (this.cur_store.SourceType =="pandaapi") {
        this.cur_store.SourceParameter = JSON.stringify({
          PandaStoreID: this.PandaStoreID,
          PandaAccessKey: this.PandaAccessKey,
          PandaSecurityKey: this.PandaSecurityKey,
        });
      }

      for (var key in this.cur_store) {
        bodyFormData.append(key, this.cur_store[key]);
      }

      axios({
        method: "post",
        url: "/Api/Web/Store/updateOnlineStoreInfo",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.get_online_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async upload_online_menu(event) {
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uploadStoreData",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                that.text_message = rt.data.message;
              } else if (rt.message) {
                that.text_message = rt.message;
              } else {
                that.text_message = "Unknown return message";
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async get_api_info(event) {
      if (event) {
        event.preventDefault();
      }
      this.text_message = "";
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getSourceStoreInfo",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                that.text_message = rt.data.message;
              } else if (rt.message) {
                that.text_message = rt.message;
              } else {
                that.text_message = "Unknown return message";
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async get_online_list() {
      // this will be called only after form is valid. You can do api call here to login
      this.currpage = "list";
      this.text_message = "";
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.new_store.LocationID);
      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Store/getOnlineStoreList",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.storelist = rt.data.stores;
              that.menuList = rt.data.menuList;
              that.Menu_IDn = 0;
              if (that.storelist.length > 0) {
                let lpara = that.storelist[0].LocalParameter;
                if (lpara) {
                  let lseting = JSON.parse(lpara);
                  if (lseting) {
                    if (lseting.Menu_IDn) {
                      that.Menu_IDn = lseting.Menu_IDn;
                    }
                  }
                }
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.new_store.LocationID = this.$route.query.LocationID;
      if (!this.new_store.LocationID) {
        this.$router.push("/store");
        return;
      }
      return this.get_online_list();
    },
  },
  mounted() {
    let name = getStore("username");
    if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
      this.pkadmin = true;
    } else {
      this.$router.push("/store");
      return;
    }

    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style>
.content {
  padding-top: 80px;
}
.store_radio_div {
  padding-top: 0.5rem;
}
.input_height_1_5 {
  height: 1.5rem;
  padding: 0 0.75rem;
}
.picimg {
  max-height: 14rem;
}
#fp {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-color: #ced4da !important;
  background-color: white !important;
}
</style>
